import './addAddress.scss';

export const AddAddressComponent = {
    template: `
        <ng-form name="$ctrl.addAddressForm">
        <fieldset>
            <div ng-if="$ctrl.save === 'enabled'" class="flex-row expand">
                <div class="column column-md-4">
                    <oo-input-container>
                        <input
                            id="field-name"
                            name="address-name"
                            ng-model="$ctrl.address.name"
                            ng-required="true"
                            type="text"
                        />
                        <label>Label</label>
                        <div ng-messages="$ctrl.addAddressForm['address-name'].$error">
                            <div ng-messages-include="generic-messages"></div>
                        </div>
                    </oo-input-container>
                </div>
            </div>

            <oo-input-container>
                <geo-suggest-input
                    autocomplete="address-line1"
                    name="address"
                    id="field-address-1"
                    initial-address="$ctrl.address"
                    is-required="true"
                    on-address-selection="$ctrl.onAddressSelection(address)"
                    on-focus="$ctrl.clearOldData()"
                    use-mapbox="true"
                ></geo-suggest-input>
                <label>Address</label>
                <div ng-messages="$ctrl.addAddressForm['geo-input-suggest'].$error">
                    <div ng-messages-include="generic-messages"></div>
                    <div ng-message="autocomplete-required">Enter a valid address</div>
                </div>
            </oo-input-container>

            <oo-input-container>
                <input
                    autocomplete="address-line2"
                    id="field-address-2"
                    maxlength="30"
                    name="address-line2"
                    ng-change="$ctrl.convertEmptyToNull()"
                    ng-model="$ctrl.address2"
                    type="text"
                />
                <label>Apt / Suite #</label>
            </oo-input-container>

            <div class="flex-row expand">
                <div class="column column-md-4">
                    <oo-input-container>
                        <input
                            autocomplete="locality"
                            id="field-city"
                            name="city"
                            ng-change="$ctrl.clearOldData()"
                            ng-model="$ctrl.address.city"
                            ng-required="true"
                            type="text"
                        />
                        <label>City</label>
                        <div ng-messages="$ctrl.addAddressForm.city.$error">
                            <div ng-messages-include="generic-messages"></div>
                        </div>
                    </oo-input-container>
                </div>

                <div class="column column-md-4">
                    <oo-input-container>
                        <input
                            autocomplete="region"
                            id="field-state"
                            maxlength="2"
                            name="state"
                            ng-change="$ctrl.clearOldData()"
                            ng-model="$ctrl.address.state"
                            ng-required="true"
                            type="text"
                        />
                        <label>State</label>
                        <div ng-messages="$ctrl.addAddressForm.state.$error">
                            <div ng-messages-include="generic-messages"></div>
                        </div>
                    </oo-input-container>
                </div>

                <div class="column column-md-4">
                    <oo-input-container>
                        <input
                            autocomplete="postal-code"
                            id="field-zip"
                            maxlength="7"
                            name="zip"
                            ng-change="$ctrl.clearOldData()"
                            ng-model="$ctrl.address.zipCode"
                            ng-required="true"
                            type="tel"
                        />
                        <label>Zip</label>
                        <div ng-messages="$ctrl.addAddressForm.zip.$error">
                            <div ng-messages-include="generic-messages"></div>
                        </div>
                    </oo-input-container>
                </div>
            </div>

            <oo-input-container>
                <input
                    type="text"
                    name="instructions"
                    ng-change="$ctrl.convertEmptyToNull()"
                    ng-model="$ctrl.notes"
                    id="field-notes"
                    maxlength="300"
                />
                <label>Delivery Instructions</label>
            </oo-input-container>

            <div class="checkbox-container" ng-if="$ctrl.save === 'optional'">
                <input id="save-address" ng-change="$ctrl.clearName()" c-check type="checkbox" ng-model="$ctrl.address.shouldSave">
                <label for="save-address">Save Address</label>
            </div>

            <div class="flex-row expand" ng-if="$ctrl.address.shouldSave && $ctrl.save === 'optional'">
                <div class="column column-md-4">
                    <oo-input-container>
                        <label>Label</label>
                        <input type="text" ng-required="true" ng-model="$ctrl.address.name" id="field-new-address-name" name="address-name">
                        <div ng-messages="$ctrl.addAddressForm['address-name'].$error">
                            <div ng-messages-include="generic-messages"></div>
                        </div>
                    </oo-input-container>
                </div>
            </div>
        </fieldset>
        </ng-form>
    `,
    bindings: {
        address: '=',
        save: '@',
        onAddressSelectionCallback: '&?onAddressSelection'
    },
    controller: class {
        constructor(addressService) {
            'ngInject';
            this.addressService = addressService;
            this.address2 = this.address.address2;
            this.notes = this.address.notes;
            this.guid = this.address.guid;
        }

        onAddressSelection(address) {
            address.guid = this.guid;
            Object.assign(this.address, address);

            if (this.onAddressSelectionCallback && 'function' === typeof this.onAddressSelectionCallback) {
                this.onAddressSelectionCallback({ address: this.address });
            }
        }

        clearName() {
            this.address.name = null;
        }

        clearOldData() {
            this.address.latitude = null;
            this.address.longitude = null;
            this.address.formattedAddress = null;
            this.address.place_name = null; //eslint-disable-line
            this.address.description = null;
            this.address.streetAddress1 = null;
            this.address.streetAddress2 = null;

            this.addressService.clearAddressErrors();
        }

        convertEmptyToNull() {
            this.address.address2 = this.address2;
            this.address.notes = this.notes;

            if (!this.address2) {
                this.address.address2 = null;
            }
            if (!this.notes) {
                this.address.notes = null;
            }
        }
    }
};
